// Footer.jsx
// Location: src/components/Footer.jsx
// Main navigation footer

import React from 'react';

/**
 * Footer Component
 * Displays a simple text Made with ❤️ and 🥁
 * 
 */

const Footer = () => {
    return (
      <footer className="bg-purple-50 border-t border-gray-200 py-6 mt-12">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-gray-600 text-sm">
            Made with ❤️ and 🥁 by drummers, for drummers
          </p>
        </div>
      </footer>
    );
  };


export default Footer;